/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Card,
  Row,
  Form,
  Col,
  Button,
  Typography,
  Steps,
  message,
  Spin,
} from 'antd';
import { useHistory } from 'react-router-dom';
import {
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import NumericInput from 'components/NumericInput';
import toCurrency from 'utils/toCurrency';
import { SET_CORTE } from 'store/reducers/app';
import { onError } from 'utils/handlers';
import Previewer from 'components/Previewer';
import { getMetodosDePago } from 'api/configuracion';
import { getReporte } from 'api/recaudacion/index';
import { postCerarCorte } from 'api/recaudacion/cortes';
import { getCatalogoDeEfectivo } from 'api/catalogos';
import usePermissionMessage from 'hooks/usePermissionMessage';
import ResumenCerrarCorte from './ResumenCerrarCorte';

const { Text } = Typography;
const { Step } = Steps;
const { useForm } = Form;

export const permissionConfig = {
  mainPermission: 'change_corte',
  required: [
    'view_catalogodemetododepago',
    'view_catalogodeefectivo',
  ],
};

const CerrarCorte = ({ permission }) => {
  // Formularios
  const history = useHistory();
  const [form] = useForm();
  const [form2] = useForm();
  const [form3] = useForm();
  const [form4] = useForm();
  const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'migob';

  // Variables Previewer
  const [base64, setBase64] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);

  // Totales de efectivo y todos los metodos de pago
  const [totalMonedas, setTotalMonedas] = useState(0);
  const [totalBilletes, setTotalBilletes] = useState(0);

  // Variables generales para el funcionamiento del componente
  const [currentStep, setCurrentStep] = useState(0);
  const [metodosDePago, setMetodosDePago] = useState([]);
  const [loading, setLoading] = useState(false);
  const [metodosDePagoResumen, setMetodosDePagoResumen] = useState([]);

  const [monedasValues, setMonedasValues] = useState([]);
  const [billetesValues, setBilletesValues] = useState([]);
  const [catEfectivo, setCatEfectivo] = useState([]);

  const dispatch = useDispatch();
  const corte = useSelector(({ app }) => app.corte);

  usePermissionMessage(permission);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      if (!corte?.apertura) {
        setTimeout(() => {
          history.push('/recaudacion/corte/abrir-corte/');
        });
        message.warn('Se necesita un corte abierto para poder acceder');
      }
      const dataMetodosDePago = await getMetodosDePago();
      const _catalogoDeEfectivo = await getCatalogoDeEfectivo();
      if (mounted) {
        setMetodosDePago(dataMetodosDePago);
        setCatEfectivo(_catalogoDeEfectivo);
      }
    };
    fetchData();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [corte]);

  const getReporteDeCierre = async (key) => {
    setLoading(true);
    const result = await getReporte(key, '/entrega-de-caja-por-cajero/');
    if (result.success) {
      setBase64(result.base64);
      setVisiblePreview(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (typeof base64 === 'string' && !visiblePreview) {
      dispatch({
        type: SET_CORTE,
        payload: null,
      });
      history.push('/dashboard');
    }
    // eslint-disable-next-line
  }, [visiblePreview]);

  const onFinish = async () => {
    setLoading(true);
    const registros_de_recaudacion = [...metodosDePagoResumen];
    const { total_efectivo } = form4.getFieldsValue();
    const desgloses = [
      ...monedasValues,
      ...billetesValues,
    ].filter((e) => e.cantidad);

    if (total_efectivo) {
      registros_de_recaudacion.push({
        importe: total_efectivo,
        metodo_de_pago: 1,
        desgloses,
      });
    }
    // if (total_efectivo) {
    //   registros_de_recaudacion.push({ importe: total_efectivo, metodo_de_pago: 1 });
    // }
    const successed = await postCerarCorte(corte.id, registros_de_recaudacion);
    if (successed) setTimeout(() => { getReporteDeCierre(corte.id); });
    setLoading(false);
  };

  const validateForms = async () => {
    await form.validateFields();
    await form2.validateFields();
    await form3.validateFields();
    await form4.validateFields();
  };

  const prev = () => {
    const prevStep = currentStep - 1;
    if (currentStep === 0) {
      history.push('/dashboard');
    } else {
      setCurrentStep(prevStep);
    }
  };

  const next = async () => {
    try {
      await validateForms();
      if (ENV_NAME === 'nayarit') {
        const nextStep = currentStep + 1;
        if (currentStep === 1) {
          onFinish();
        } else {
          setCurrentStep(nextStep);
        }
      } else {
        const nextStep = currentStep + 1;
        if (currentStep === 3) {
          onFinish();
        } else {
          setCurrentStep(nextStep);
        }
      }
    } catch (err) {
      onError(err);
    }
  };

  const StepNay = () => (
    <b>
      {currentStep === 1 ? 'Cerrar Corte' : 'Siguiente'}
    </b>
  );

  const NormalSteps = () => (
    <b>
      {currentStep === 3 ? 'Cerrar Corte' : 'Siguiente'}
    </b>
  );

  const StepControls = () => (
    <Row
      justify="space-between"
      align="middle"
      style={{ width: '100%', padding: '10px 0' }}
    >
      <Button type="link" onClick={prev}>
        <LeftOutlined />
        {currentStep === 0 ? 'Dashboard' : 'Atrás'}
      </Button>
      <Button type="link" onClick={next}>
        {ENV_NAME === 'nayarit' ? (
          <StepNay />
        ) : (
          <NormalSteps />
        )}
        <RightOutlined />
      </Button>
    </Row>
  );

  const focusInput = (currentInput) => {
    const input = document.getElementById(currentInput);
    if (input) {
      input.focus();
    }
  };

  const StepDetalleMonedas = () => (
    <Row gutter={10}>
      <Col xs={24} sm={24} md={24}>
        <Card
          bordered={false}
          title={(
            <Text>
              Total :
              {' '}
              {toCurrency(totalMonedas)}
            </Text>
          )}
        >
          <Form
            onValuesChange={(changedValues, allValues) => {
              const changed = Object.keys(changedValues).shift();
              const {
                moneda_7,
                moneda_8,
                moneda_9,
                moneda_10,
                moneda_11,
                moneda_12,
              } = allValues;
              let total = 0;
              if (moneda_7) {
                total += (parseInt(moneda_7, 10) || 0) * 0.5;
              }
              if (moneda_8) {
                total += (parseInt(moneda_8, 10) || 0);
              }
              if (moneda_9) {
                total += (parseInt(moneda_9, 10) || 0) * 2;
              }
              if (moneda_10) {
                total += (parseInt(moneda_10, 10) || 0) * 10;
              }
              if (moneda_11) {
                total += (parseInt(moneda_11, 10) || 0) * 20;
              }
              if (moneda_12) {
                total += (parseInt(moneda_12, 10) || 0) * 5;
              }
              setTotalMonedas(total);
              const keys = Object.entries(allValues).map((e) => ({
                catalogo_de_efectivo: parseInt(e[0].split('_')[1], 10),
                cantidad: e[1] ? parseInt(e[1], 10) : undefined,
              }));
              setMonedasValues(keys);
              setTimeout(() => {
                focusInput(changed);
              });
            }}
            layout="vertical"
            form={form}
          >
            <Row gutter={10}>
              {catEfectivo.map((moneda) => !moneda.es_billete && (
                <Col xs={24} sm={24} md={8} key={moneda.id}>
                  <NumericInput
                    name={`moneda_${moneda.id}`}
                    label={`${toCurrency(moneda.denominacion)} ${moneda.id === 11 ? '(Moneda)' : ''}`}
                    commas
                  />
                </Col>
              ))}

            </Row>
          </Form>
        </Card>
      </Col>
    </Row>
  );

  const StepDetalleBilletes = () => (
    <Row>
      <Col xs={24} sm={24} md={24}>
        <Card
          bordered={false}
          title={<Total total={totalBilletes} />}
        >
          <Form
            onValuesChange={(changedValues, allValues) => {
              const changed = Object.keys(changedValues).shift();
              const {
                billete_1,
                billete_2,
                billete_3,
                billete_4,
                billete_5,
                billete_6,
              } = allValues;
              let total = 0;
              if (billete_1) {
                total += (parseInt(billete_1, 10) || 0) * 20;
              }
              if (billete_2) {
                total += (parseInt(billete_2, 10) || 0) * 50;
              }
              if (billete_3) {
                total += (parseInt(billete_3, 10) || 0) * 100;
              }
              if (billete_4) {
                total += (parseInt(billete_4, 10) || 0) * 200;
              }
              if (billete_5) {
                total += (parseInt(billete_5, 10) || 0) * 500;
              }
              if (billete_6) {
                total += (parseInt(billete_6, 10) || 0) * 1000;
              }
              setTimeout(() => {
                focusInput(changed);
              });
              const keys = Object.entries(allValues).map((e) => ({ catalogo_de_efectivo: parseInt(e[0].split('_')[1], 10), cantidad: e[1] ? parseInt(e[1], 10) : undefined }));
              setTotalBilletes(total);
              setBilletesValues(keys);
            }}
            layout="vertical"
            form={form2}
          >
            <Row gutter={10}>
              {catEfectivo.map((efectivo) => efectivo.es_billete && (
                <Col xs={24} sm={24} md={8} key={efectivo.id}>
                  <NumericInput
                    name={`billete_${efectivo.id}`}
                    label={`${toCurrency(efectivo.denominacion)}  ${efectivo.id === 1 ? '(Billete)' : ''}`}
                    commas
                  />
                </Col>
              ))}
            </Row>
          </Form>
        </Card>
      </Col>
    </Row>
  );

  const StepOtrosMetodos = () => (
    <Row gutter={10}>
      <Col sm={24} md={24} lg={24}>
        <Card
          bordered={false}
          title={(
            <Total
              total={metodosDePagoResumen
                .reduce((acc, curr) => acc + parseFloat(curr.importe) || 0, 0)}
            />
          )}
        >
          <ResumenCerrarCorte
            metodos={metodosDePago.filter((item) => item.id !== 1)}
            setOtrasFormasDePago={setMetodosDePagoResumen}
            otrasFormasDePago={metodosDePagoResumen}
          />
        </Card>
      </Col>
    </Row>
  );

  const StepTotalRecaudado = () => (
    <Col sm={24} md={24} lg={24}>
      <Card
        bordered={false}
        title={(
          <Total
            total={metodosDePagoResumen
              .reduce((acc, curr) => acc + parseFloat(curr.importe) || 0, 0)
              + totalMonedas + totalBilletes}
          />
        )}
      >
        <Form
          form={form4}
          layout="vertical"
        >
          <Row gutter={10}>
            {ENV_NAME !== 'nayarit' && (
              <Col xs={24} sm={24} md={12} lg={8}>
                <NumericInput
                  name="total_efectivo"
                  label="Total efectivo"
                  currency
                  disabled
                  decimal
                  allowZero
                />
              </Col>
            )}
            <Col xs={24} sm={24} md={12} lg={8}>
              <NumericInput
                name="total_otros"
                label={ENV_NAME === 'nayarit' ? 'Total' : 'Total otros'}
                currency
                disabled
                allowZero
                decimal
              />
            </Col>
          </Row>
        </Form>
      </Card>
    </Col>
  );

  useEffect(() => {
    form4.setFieldsValue({
      total_efectivo: totalMonedas + totalBilletes,
      total_otros: metodosDePagoResumen
        .reduce((acc, curr) => acc + parseFloat(curr.importe) || 0, 0),
    });
    form3.setFieldsValue({
      1: totalMonedas + totalBilletes,
    });
    // eslint-disable-next-line
  }, [totalMonedas, totalBilletes, metodosDePagoResumen]);

  const steps = [
    {
      key: 1,
      icon: null,
      title: 'Detalle de Monedas',
      component: <StepDetalleMonedas />,
    },
    {
      key: 2,
      icon: null,
      title: 'Detalle de Billetes',
      component: <StepDetalleBilletes />,
    },
    {
      key: 3,
      icon: null,
      title: 'Otros Tipos de Pago',
      component: <StepOtrosMetodos />,
    },
    {
      key: 4,
      icon: null,
      title: 'Total Recaudado',
      component: <StepTotalRecaudado />,
    },
  ];
  const stepsNay = [
    {
      key: 3,
      icon: null,
      title: 'Tipos de Pago',
      component: <StepOtrosMetodos />,
    },
    {
      key: 4,
      icon: null,
      title: 'Total Recaudado',
      component: <StepTotalRecaudado />,
    },
  ];

  const FormSteps = () => (
    <>
      <br />
      {ENV_NAME === 'nayarit' ? (
        <Steps size="small" current={currentStep}>
          {stepsNay.map((step) => (
            <Step title={step.title} key={step.key} />
          ))}
        </Steps>
      ) : (
        <Steps size="small" current={currentStep}>
          {steps.map((step) => (
            <Step title={step.title} key={step.key} />
          ))}
        </Steps>
      )}
      <StepControls />
    </>
  );

  // eslint-disable-next-line react/prop-types
  const Total = ({ total }) => (
    <Text>
      Total :
      {' '}
      {toCurrency(total)}
    </Text>
  );

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Row>
            <FormSteps />
            {permission.hasAllViewPermission && (
              ENV_NAME === 'nayarit' ? (
                <div className="steps-content">
                  {stepsNay[currentStep]?.component}
                </div>
              ) : (
                <div className="steps-content">
                  {steps[currentStep]?.component}
                </div>
              )
            )}
          </Row>
        </Spin>
      </Col>
      <Previewer
        visible={visiblePreview}
        setVisible={setVisiblePreview}
        base64={base64}
      />
    </Row>
  );
};

export default CerrarCorte;
